import React, { useState, useEffect, useRef } from 'react';
import { wikiAPI } from '../services/api';

const WikiImage = ({ src, alt, ...props }) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    // Cleanup previous object URL if exists
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }
    
    // Check if this is a wiki image URL
    if (src && src.includes('/api/wiki/images/')) {
      const imageId = src.split('/api/wiki/images/')[1]?.split('?')[0];
      if (imageId) {
        // Fetch image through authenticated API
        const fetchImage = async () => {
          try {
            setLoading(true);
            const imageUrl = wikiAPI.getImageUrl(imageId);
            const token = localStorage.getItem('token');
            
            const response = await fetch(imageUrl, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            
            if (response.ok) {
              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              objectUrlRef.current = url;
              setImageUrl(url);
              setError(false);
            } else {
              setError(true);
            }
          } catch (err) {
            setError(true);
          } finally {
            setLoading(false);
          }
        };
        
        fetchImage();
      } else {
        setImageUrl(src);
        setLoading(false);
      }
    } else {
      // Regular image URL, use as-is
      setImageUrl(src);
      setLoading(false);
    }
    
    // Cleanup object URL on unmount or src change
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [src]);

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-secondary)' }}>
        Loading image...
      </div>
    );
  }

  if (error || !imageUrl) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-secondary)', border: '1px dashed var(--border-color)', borderRadius: '4px' }}>
        Failed to load image
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={alt || ''}
      style={{ maxWidth: '100%', height: 'auto', ...props.style }}
      {...props}
    />
  );
};

export default WikiImage;

